import { useSelector } from 'react-redux';
import { useFeatureFlags } from '../toggle_tools/featureFlagTools';
import { getPartnerIdFromApplication, selectChannelPartnerGuid } from '../selectors';

/**
 * usePartnerWantsHidden determines whether the current partner wants the Save for later and Start over buttons to be hidden
 * based on the hideSaveForLaterAndStartOverButtons feature flag
 */
const usePartnerWantsHidden = () => {
  const { hideSaveForLaterAndStartOverButtons } = useFeatureFlags();
  const partnerGUID = useSelector(selectChannelPartnerGuid);
  const partnerIdFromApplication = useSelector(getPartnerIdFromApplication);

  const partnerId = partnerGUID ?? partnerIdFromApplication;

  const hideSaveForLaterStartOverButtons = Boolean(
    partnerId && hideSaveForLaterAndStartOverButtons?.channel_partner_ids.includes(partnerId)
  );

  return {
    hideSaveForLaterStartOverButtons,
  };
};

export default usePartnerWantsHidden;
